import "./panel.css";

interface ColumnsPanelProps {
    columns: any;
    isOpen: boolean;
}

const ColumnsPanel = ({ columns, isOpen }: ColumnsPanelProps) => {
    return (
        <div className={`panel-container ${isOpen ? 'open' : ''}`}>
            columns
        </div>
    );
}

export default ColumnsPanel;